import { s as script, a as script$1 } from './DropdownItem-yQcaSZL4.js';
import { a as registerComponent } from './plugins-C7548x21.js';
import 'vue';
import './trapFocus-IMs77O3T.js';
import './config-nHWiBviw.js';
import './helpers-O9h6_ICO.js';
import './typeof-Z4rCTFCZ.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script);
    registerComponent(Vue, script$1);
  }
};

export { script as BDropdown, script$1 as BDropdownItem, Plugin as default };
